import React, { useState } from 'react'
import styled from "@emotion/styled";
import { styled as MUIStyled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { Box, Popover } from "@mui/material"
import { GENERATE_ICON } from "../../../../constants/icons/GenerateIcon";
import { REPHRASE_ICON } from "../../../../constants/icons/RephraseIcon";
import { INFO_ICON } from "../../../../constants/icons/InfoIcon";
import { SETTINGS_ICON, SETTINGS_ICON_DISABLED } from "../../../../constants/icons/SettingsIcon";
import { LEFT_DISABLED, LEFT_ENABLE, RIGHT_DISABLED, RIGHT_ENABLE } from "../../../../constants/icons/ArrowIcon";
import { CROSS_ICON } from '../../../../constants/icons/CrossIcon';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { resetEmailData } from '../../../../redux/slice/campaignSlice';
import { COLOR_MAP } from '../../../../constants/ColorNames';
import { renderToStaticMarkup } from 'react-dom/server';
import { NOT_ALLOWED_ICON } from '../../../../constants/icons/NotAllowedIcon';
import { TabStatesProps } from '../../../../types/dataTypes';

type GenerateByAiButtonProps = {
  handleGenerate: () => void,
  handleRephrase: (currentTone: string) => void,
  // setRephraseCount: (current: number) => void,
  navigateRephrase: (curr: number) => void,
  handleFollowup: ({}) => void,
  currentTab: string,
  generateOrRephrase: string,
  buttonWidth: string,
  rephraseCount: number, // handle logic
  currentCount: number,
  disableGenerateContent: boolean,
  revealingContent: boolean,
  selectedTones: any,
  setSelectedTones: any,
  selectedLengths: any,
  setSelectedLengths: any,
  JDGeneratedByAi: boolean,
  rePhraseFeature: boolean
}
const Button = styled.div`
  /* width: 321px; */
  height: 44px;
  padding: 0px 16px 0px 16px;
  border-radius: 24px;
  background: linear-gradient(white, white) padding-box, linear-gradient(91.27deg, #E119A0 4%, #00AEFF 33.4%, #FC5912 61.29%, #73D7C3 99.65%) border-box;
  border: 1px solid transparent;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.15);
  gap: 16px;
  cursor: pointer;
  /* position: absolute; */
  bottom: 0;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.15), 0px 4px 8px -2px rgba(0, 0, 0, 0.08);
  align-items: center;
`
const Container = styled.div`
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  height: 44px;
`

const PopperHeading = styled(Box)`
  color: var(--color-grey-90, #06050A);
  font-family: Noto Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`
const PopperContent = styled(Box)`
  color: var(--color-grey-black, #000);
  font-family: Noto Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-top: 1px solid #F6F6F7;
  display: flex;
  padding: 16px;
`

const Tags = styled(Box)((props) => ({
  height: '24px',
  width: '67px',
  borderRadius: '4px',
  padding: '2px 10px',
  backgroundColor: props.className === 'active' ? '#F0E4F8' : '#F6F6F7',
  cursor: 'pointer'
}))

const ItemBox = styled(Box)`
  height: 44px;
  display: flex;
  align-items: center;
  font-family: Noto Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  @keyframes rotate {
  100% {transform: rotate(360deg);}
  }
`

const BootstrapTooltip = MUIStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));


const GenerateByAiButton = (props: GenerateByAiButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const templateSelected = useSelector((state: RootState) => state.campaign.templateSelected);
  const tabState = useSelector((state: RootState) => state.campaign.tabState);
  const selectedTab = useSelector((state: RootState) => state.campaign.selectedTab);
  const campaignTemplate = useSelector((state: RootState) => state.campaign.campaignTemplate);
  const selectedTabData = tabState.find((tab: TabStatesProps) => tab.label === selectedTab)
  const email = selectedTabData?.email || ''

  const dispatch = useDispatch()

  const {
    generateOrRephrase,
    rephraseCount,
    buttonWidth,
    currentTab,
    handleGenerate,
    handleFollowup,
    navigateRephrase,
    handleRephrase,
    currentCount,
    disableGenerateContent,
    revealingContent,
    selectedTones,
    setSelectedTones,
    selectedLengths,
    setSelectedLengths,
    JDGeneratedByAi,
    rePhraseFeature
  } = props;

  const generate = () => {
    if (currentTab == 'Email') {
      handleGenerate();
    } 
    else {
      handleFollowup({});
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, direction: string) => {
    event.stopPropagation();

    if (disableGenerateContent) {
      return
    }
    if (direction == 'left' && currentCount != 1) {
      navigateRephrase(currentCount - 1)
    } else if (direction == 'right' && currentCount < rephraseCount) {
      navigateRephrase(currentCount + 1)
    }
  }

  const doRephrase = () => {
    // if (rephraseCount != 4) {
    if (rephraseCount != 2) {
      handleRephrase("REPHRASE");
    }
  }

  const handleClickTag = (tag: 'FORMAL' | 'CASUAL' | 'ELABORATE' | 'SHORTEN', type: 'tone' | 'length') => {
    let disableApiCall = false;
    if (type === 'tone') {
      // disableApiCall = tag === selectedTone ? true : false;
      disableApiCall = (tag === selectedTones[currentCount]) ? true : false;
      // setSelectedTone(tag)
      setSelectedTones({ ...selectedTones, [currentCount]: tag })
    }
    else {
      // disableApiCall = tag === selectedLength ? true : false;
      disableApiCall = (tag === selectedLengths[currentCount]) ? true : false;
      // setSelectedLength(tag)
      setSelectedLengths({ ...selectedLengths, [currentCount]: tag })
    }
    (!disableGenerateContent && !disableApiCall) && handleRephrase(tag)
    handleClose()
  }

  const handleReset = () => {
    setSelectedLengths({})
    setSelectedTones({})
    dispatch(resetEmailData())
  }

  const TooltipComponent = <BootstrapTooltip title={
    <div style={{
      width: '440px',
      height: '430px',
      fontFamily: 'Noto Sans',
      fontSize: '14px',
      fontStyle: ' normal',
      fontWeight: 400,
      lineHeight: '20px',
      padding: '15px 12px 0 12px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column'
    }}>
      <div style={{ display: 'flex', width: '95%', alignItems: 'center', justifyContent: 'space-between', paddingBottom: '8px' }}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <INFO_ICON />
          <div style={{
            fontSize: '16px',
            fontStyle: ' normal',
            fontWeight: 700,
            lineHeight: '24px',
          }}>Important Guidelines - Prohibited Content</div>
        </div>
        <CROSS_ICON />
      </div>
      <div style={{ padding: '0 32px' }}>
        <ul>
          <li>Emails that mention religion, caste, race, or gender.</li>
          <li>Emails requesting money or any form of regular payments from job seekers.</li>
          <li>Emails promoting services like immigration assistance instead of actual job opportunities.</li>
          <li>Emails lacking clear job details, potentially giving an impression of a fake job.</li>
          <li>Emails containing links to external websites (unless specified in the sales agreement and approved by compliance).</li>
          <li>Emails promoting products, services, franchise or chain marketing, business opportunities, or training services.</li>
        </ul>
        <strong>Any outreach containing prohibited content will be reviewed and may be blocked.</strong>
      </div>
    </div>
  } placement='top'>
    <ItemBox sx={{ paddingLeft: '8px' }} ><INFO_ICON /></ItemBox>
  </BootstrapTooltip>

  return (
    <BootstrapTooltip title={templateSelected && selectedTabData?.email ? <div style={{ fontSize: '14px', padding: '4px 8px', fontFamily: 'Noto Sans', lineHeight: '22px' }}>A template has already been selected</div> : revealingContent ? <div style={{ fontSize: '14px', padding: '4px 8px', fontFamily: 'Noto Sans', lineHeight: '22px' }}>Please wait for the content to complete generating</div> : ''}>
      <Button className='ai-button' style={{
        bottom: '24px',
        marginRight: '12px',
        width: generateOrRephrase == 'generate' || (generateOrRephrase == 'rephrase' && rephraseCount === 1) ? '208px' : '321px',
        right: '12px',
        backgroundColor: 'white'
      }} >
        {generateOrRephrase == 'generate' &&
          <Container>
            <ItemBox sx={{ flex: 1, paddingX: '8px' }} onClick={disableGenerateContent || revealingContent || templateSelected ? undefined : generate}>{GENERATE_ICON}</ItemBox>

            <ItemBox sx={{
              width: '138px', paddingX: '8px', borderRight: `1px solid ${COLOR_MAP.BORDER_GREY}`, color: disableGenerateContent || revealingContent || (templateSelected && campaignTemplate && selectedTabData?.email) ? COLOR_MAP.BORDER_GREY : 'black',
              pointerEvents: disableGenerateContent || revealingContent || (templateSelected && campaignTemplate && selectedTabData?.email) ? 'unset' : 'auto', cursor: disableGenerateContent || revealingContent || (templateSelected && campaignTemplate && selectedTabData?.email) ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'pointer'
            }} onClick={disableGenerateContent || revealingContent || (templateSelected && campaignTemplate && selectedTabData?.email) ? undefined : generate}>{(JDGeneratedByAi && currentTab === 'Email' && !email && !rePhraseFeature) ? 'Rephrase' : 'Generate by AI'}</ItemBox>

            {TooltipComponent}
          </Container>
        }
        {open && //tone handling
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            sx={{
              '.MuiPaper-root': {
                maxWidth: '29.6rem'
              }
            }}
          >
            <Box sx={{ width: '297px' }}>
              <PopperHeading sx={{ padding: '16px', fontSize: '16px', lineHeight: '24px' }}>Refine communication</PopperHeading>
              <PopperContent>
                <PopperHeading sx={{ flex: 4 }}>Tone</PopperHeading>
                <Box sx={{ flex: 1, gap: '4px', display: 'flex', flexDirection: 'row' }}>
                  <Tags onClick={() => handleClickTag('FORMAL', 'tone')} className={selectedTones[currentCount] === 'FORMAL' ? 'active' : ''}>Formal</Tags>
                  <Tags onClick={() => handleClickTag('CASUAL', 'tone')} className={selectedTones[currentCount] === 'CASUAL' ? 'active' : ''}>Casual</Tags>
                </Box>
              </PopperContent>
              <PopperContent>
                <PopperHeading sx={{ flex: 4 }}>Length</PopperHeading>
                <Box sx={{ flex: 2, gap: '4px', display: 'flex', flexDirection: 'row' }}>
                  <Tags onClick={() => handleClickTag('ELABORATE', 'length')} className={selectedLengths[currentCount] === 'ELABORATE' ? 'active' : ''}>Elaborate</Tags>
                  <Tags onClick={() => handleClickTag('SHORTEN', 'length')} className={selectedLengths[currentCount] === 'SHORTEN' ? 'active' : ''}>Shorten</Tags>
                </Box>
              </PopperContent>
            </Box>
          </Popover>
        }
        {generateOrRephrase == 'rephrase' &&
          <Container>
            <Box sx={{ gap: '8px', display: 'flex', flex: 1, height: '44px', alignItems: 'center' }}>
              <ItemBox
                // className={!revealingContent && (disableGenerateContent || (rephraseCount > 3)) ? 'svg-container' : ''}
                className={!revealingContent && (disableGenerateContent || (rephraseCount > 1)) ? 'svg-container' : ''}
                // onClick={disableGenerateContent || (rephraseCount > 3) || revealingContent ? undefined : doRephrase}
                onClick={disableGenerateContent || (rephraseCount > 1) || revealingContent ? undefined : doRephrase}
                sx={{ animation: revealingContent ? 'rotate ease 1s infinite' : '' }}
              >
                {REPHRASE_ICON}
              </ItemBox>
              <ItemBox
                sx={{ paddingRight: '16px', borderRight: `1px solid ${COLOR_MAP.BORDER_GREY}`,  pointerEvents:  revealingContent ? 'unset' : 'auto', cursor:  revealingContent  ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'pointer' }}
                // className={disableGenerateContent || (rephraseCount > 3) || revealingContent ? 'disable-container' : ''}
                className={disableGenerateContent || (rephraseCount > 1) || revealingContent ? 'disable-container' : ''}
                onClick={disableGenerateContent || revealingContent ? undefined : doRephrase}>
                Rephrase
              </ItemBox>
            </Box>

            {rephraseCount > 1 && (
              <ItemBox sx={{ width: '130px', justifyContent: 'center', borderRight: `1px solid ${COLOR_MAP.BORDER_GREY}`, pointerEvents:  revealingContent ? 'unset' : 'auto', cursor:  revealingContent  ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'pointer'}}>
                <div onClick={e => { if (!(currentCount === 1 || disableGenerateContent || revealingContent)) { navigate(e, 'left') } }}>{(currentCount === 1 || disableGenerateContent || revealingContent) ? LEFT_DISABLED : LEFT_ENABLE}</div>
                <div style={{ margin: '0 10px' }}>{currentCount}/<span style={{ color: COLOR_MAP.BORDER_GREY }}>{rephraseCount}</span></div>
                <div onClick={e => { if (!(currentCount === rephraseCount || disableGenerateContent || revealingContent)) { navigate(e, 'right') } }}>{(currentCount === rephraseCount || disableGenerateContent || revealingContent) ? RIGHT_DISABLED : RIGHT_ENABLE}</div>
              </ItemBox>
            )}

            <ItemBox sx={{ paddingX: '16px' }} onClick={e => { if (!disableGenerateContent && !revealingContent) { handleClick(e) } }}>{(disableGenerateContent || revealingContent) ? SETTINGS_ICON_DISABLED : SETTINGS_ICON}</ItemBox>

            <ItemBox sx={{ paddingX: '16px', borderLeft: `1px solid ${COLOR_MAP.BORDER_GREY}` }}>
              {TooltipComponent}
            </ItemBox>
          </Container>
        }
      </Button>
    </BootstrapTooltip>
  )
}
export default GenerateByAiButton 